import React, { useState } from "react";
import { t } from "../../utils/i18n";
import {
  Formik,
  Form,
  Field,
  FormikHelpers,
  FieldArray,
  ErrorMessage
} from "formik";
import { url } from "./validations";
import { postRequest, putRequest } from "../../utils/httpRequest";
import { formErrors } from "../../utils/formErrors";

import woocommerceWordpressLogo from "../../../assets/images/integrations/woocommerce-wordpress.png";

const WordPressForm = ({ store_id, integration, showSuccessModal }) => {
  const [creating, setCreating] = useState(false);
  const [errors, setErrors] = useState({});

  const formattedErrors = errors => {
    const validationErrors = {};
    const redirectUrlError = errors["redirect_url"];
    const returnUrlError = errors["return_url"];
    const alternateRedirectUrlError = errors["alternate_redirect_url"];
    const webhookUrlError = errors["webook_url"];

    validationErrors.redirectUrlError = redirectUrlError;
    validationErrors.returnUrlError = returnUrlError;
    validationErrors.alternateRedirectUrlError = alternateRedirectUrlError;
    validationErrors.webhookUrlError = webhookUrlError;

    return validationErrors;
  };

  const submit = values => {
    const crsfToken = $('meta[name="csrf-token"]').attr("content");

    const data = {
      store_integration: values
    };
    setCreating(true);

    if (integration) {
      putRequest(`/stores/${store_id}/integrations/${integration.id}`, data, {
        "X-CSRF-Token": crsfToken
      })
        .then(response => {
          showSuccessModal();
      })
        .catch(error => {
          const errors = formErrors(error.data.errors);

          setErrors(error);
          setCreating(false);
        });
    } else {
      postRequest(`/stores/${store_id}/integrations`, data, {
        "X-CSRF-Token": crsfToken
      })
        .then(response => {
          window.location = `/stores/${store_id}/integrations`;
        })
        .catch(error => {
          const errors = formErrors(error.data.errors);

          setErrors(error);
          setCreating(false);
        });
    }
  };

  return (
    <Formik
      initialValues={{
        redirect_url: integration?.redirect_url || "",
        return_url: integration?.return_url || "",
        webhook_url: integration?.webhook_url || "",
        enable_subscriptions: integration?.enable_subscriptions || false,
        alternate_redirect_url: integration?.alternate_redirect_url || "",
        integration_type: "WooCommerce Plugin"
      }}
      onSubmit={values => submit(values)}
    >
      {({ values, touched, handleChange }) => (
        <Form className="form">
          <div className="text-muted font-0_8">
            <h5 className="pl-0">
              {" "}
              <img src={woocommerceWordpressLogo} width="180" /> {t("store_integrations.woo_form.quick_install")}
            </h5>
            <div id="integrationsWoocommerceHelp">
              <div className="pl-2 ml-3 mb-3">
                <i className="fa fa-question-circle"></i>{" "}
                <a
                  href="https://www.bananacrystal.com/docs/how-to-install-the-wordpress-woocommerce-plugin/"
                  target="_blank"
                >
                  {t("store_integrations.woo_form.how_to_install")}
                </a>
              </div>
            </div>
          </div>
          <div className="text-center pt-2 pb-2">
            <hr />
            <h4 className="pt-2 pb-2 store-default-title">{t("store_integrations.common.settings")}</h4>
            <hr />
          </div>
          <div className="pt-2 pb-2">
            <div className="form-group row required">
              <label htmlFor="redirect_url" className="form-label store-new-formlabel">
                {t("store_integrations.woo_form.redirect_label")}
              </label>
              <Field
                id="redirect_url"
                name="redirect_url"
                className="form-control font-0_75"
                validate={url}
                onChange={handleChange}
              />
              <ErrorMessage name="redirect_url">
                {msg => <div className="error">{msg}</div>}
              </ErrorMessage>
              {errors?.redirectUrlError && (
                <div className="error text-danger">
                  {validationErrors.redirectUrlError}
                </div>
              )}

            </div>
            <div className="text-muted row font-0_75">
                {t("store_integrations.woo_form.redirect_help")}
                <br />
                <br />
                {t("store_integrations.common.example")} https://mystore.com/checkout/order-received/
                <strong>order_id</strong>/?key=wc_order_<strong>key. </strong> 
                {t("store_integrations.woo_form.note_order_key")}
              </div>
          </div>
          <div className="pt-2 pb-2">
            <div className="form-group row required">
              <label htmlFor="redirect_url" className="form-label store-new-formlabel">
                {t("store_integrations.woo_form.return_label")}
              </label>
              <Field
                id="return_url"
                name="return_url"
                className="form-control font-0_75"
                validate={url}
                onChange={handleChange}
              />
              <ErrorMessage name="return_url">
                {msg => <div className="error">{msg}</div>}
              </ErrorMessage>
              {errors?.returnUrlError && (
                <div className="error text-danger">
                  {validationErrors.returnUrlError}
                </div>
              )}
            </div>
            <div className="text-muted row font-0_75 pt-3 pb-3">
                {t("store_integrations.woo_form.return_help")}
                <br />
                <br />
                {t("store_integrations.common.example")} https://mystore.com/checkout/order-pay/
                <strong>order_id</strong>/?key=wc_order_<strong>key. </strong>
                {t("store_integrations.woo_form.note_order_key")}
              </div>
          </div>
          <div className="form-group row required">
            <label htmlFor="webhook_url" className="form-label store-new-formlabel">
              {t("store_integrations.woo_form.webhook_label")}
            </label>
            <Field
              id="webhook_url"
              name="webhook_url"
              className="form-control font-0_75"
              validate={url}
              onChange={handleChange}
            />
            <ErrorMessage name="webhook_url">
              {msg => <div className="error">{msg}</div>}
            </ErrorMessage>
            {errors?.webhookUrlError && (
              <div className="error text-danger">
                {validationErrors.webhookUrlError}
              </div>
            )}

          </div>
          <div className="text-muted row font-0_75 row pl-0 pt-3 pb-3">
              {t("store_integrations.woo_form.webhook_help")}
              <br />
              <br />
              {t("store_integrations.common.example")} https://mystore.com/?wc-api=wc-api=wo_banana_crystal
            </div>

          <div className="form-group row required form-check pt-3">
            <Field
              type="checkbox"
              name="enable_subscriptions"
              className="form-check-input"
              id="subscriptions"
            />
            <label className="form-check-label" htmlFor="subscriptions">
              <b>{t("store_integrations.woo_form.enable_subscriptions")}</b>
            </label>
            <ErrorMessage name="enable_subscriptions">
              {msg => <div className="error">{msg}</div>}
            </ErrorMessage>
          </div>
          { values.enable_subscriptions && (<div className="pt-2 pb-2">
            <div className="form-group row required">
              <label htmlFor="redirect_url" className="form-label store-new-formlabel">
                {t("store_integrations.woo_form.subs_label")}
              </label>
              <Field
                id="alternate_redirect_url"
                name="alternate_redirect_url"
                className="form-control font-0_75"
                validate={url}
                onChange={handleChange}
              />
              <ErrorMessage name="alternate_redirect_url">
                {msg => <div className="error">{msg}</div>}
              </ErrorMessage>
              {errors?.alternateRedirectUrlError && (
                <div className="error text-danger">
                  {validationErrors.alternateRedirectUrlError}
                </div>
              )}
              
            </div>
            <div className="text-muted row font-0_75 pt-3 pb-3">
                {t("store_integrations.woo_form.subs_help")}
                <br />
                <br />
                {t("store_integrations.common.example")} https://mystore.com/my-account/bc-subscription/
              </div>
          </div>) }

          <div className="form actions">
            <div className="row mx-auto">
              <div className="col-md-12 text-right pr-0 pt-4">
                <button
                  type="submit"
                  className="btn btn-primary store-paidbtn"
                  disabled={creating}
                >
                  {creating && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {t("store_integrations.common.save")}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default WordPressForm;
